import {
  getAPIBaseURL,
  getBasicAuth,
  getAPIVersion,
  getDeviceUUID,
  getSetter,
  getXBrandID,
} from './clientHelpers';
import { isWeb } from '../../helpers/platformHelpers';

type Headers = Record<string, string>;
export class EventsClient {
  eventSource: any;

  async initialize() {
    const basicAuth = getBasicAuth();
    const apiBaseURL = getAPIBaseURL();
    const apiVersion = getAPIVersion();
    const deviceUUID = getDeviceUUID();
    const xBrandID = getXBrandID();
    const headers: Headers = {
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    };

    if (basicAuth) {
      headers.Authorization = basicAuth;
    }

    if (apiVersion) {
      headers['X-API-Version'] = apiVersion;
    }

    if (deviceUUID) {
      headers['X-Device-UUID'] = deviceUUID;
    }

    if (xBrandID) {
      headers['X-Brand-ID'] = xBrandID;
    }

    const eventsURL = `${apiBaseURL.replace(/\/?$/, '')}/events`;
    // @ts-ignore
    if (!isWeb()) {
      const rnHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        Connection: 'keep-alive',
        ...headers,
      } as Headers;
      // Use react-native-sse only (no fallback)
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const RNSSERaw = require('react-native-sse');
      const RNEventSource =
        RNSSERaw.EventSource || RNSSERaw.default || RNSSERaw;
      this.eventSource = new RNEventSource(eventsURL, {
        headers: rnHeaders,
        method: 'GET',
      });
    } else {
      const { EventSourcePolyfill } = await import('event-source-polyfill');
      this.eventSource = new EventSourcePolyfill(eventsURL, { headers });
    }
  }

  start() {
    if (this.eventSource) {
      try {
        this.eventSource.addEventListener?.('open', () => {
          // @ts-ignore
          // console.log('SSE connection opened');
        });
        this.eventSource.addEventListener?.('error', () => {
          // @ts-ignore
          // console.log('SSE connection error', e?.message || e);
        });
        this.eventSource.addEventListener?.('message', () => {
          // @ts-ignore
          // console.log('SSE message', e?.data?.slice?.(0, 120) || '<no-data>');
        });
      } catch {
        // no-op
      }
      this.eventSource.addEventListener('user', ({ data }: any) => {
        getSetter.setUser(JSON.parse(data));
      });
      this.eventSource.addEventListener('rental', ({ data }: any) => {
        getSetter.setRentalData(JSON.parse(data));
      });
      this.eventSource.addEventListener('driverCarStatus', ({ data }: any) => {
        getSetter.setDriverCarStatus(JSON.parse(data));
      });
      this.eventSource.addEventListener('booking', ({ data }: any) => {
        getSetter.updateBooking(JSON.parse(data));
      });
    }
  }

  stop() {
    if (this.eventSource) {
      if (!isWeb()) {
        this.eventSource?.removeAllListeners?.();
      }
      this.eventSource?.close?.();
    }
  }
}
